/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Signup_GenericInputs */

const en_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signup failed. Please try again.`)
};

const de_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung fehlgeschlagen. Bitte versuch es erneut.`)
};

const fr_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription échouée. Réessaie.`)
};

const es_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de registro. Por favor, inténtelo de nuevo.`)
};

const it_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione non riuscita. Riprova.`)
};

const nl_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registratie mislukt. Probeer het opnieuw.`)
};

const pl_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestracja nie powiodła się. Spróbuj ponownie.`)
};

const fi_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekisteröityminen epäonnistui. Yritä uudelleen.`)
};

const da_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelse mislykkedes. Prøv igen.`)
};

const sv_auth_error_signup_generic = /** @type {(inputs: Auth_Error_Signup_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrering misslyckades. Försök igen.`)
};

/**
* | output |
* | --- |
* | "Signup failed. Please try again." |
*
* @param {Auth_Error_Signup_GenericInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_error_signup_generic = /** @type {((inputs?: Auth_Error_Signup_GenericInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Signup_GenericInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_error_signup_generic(inputs)
	if (locale === "fr") return fr_auth_error_signup_generic(inputs)
	if (locale === "es") return es_auth_error_signup_generic(inputs)
	if (locale === "it") return it_auth_error_signup_generic(inputs)
	if (locale === "nl") return nl_auth_error_signup_generic(inputs)
	if (locale === "pl") return pl_auth_error_signup_generic(inputs)
	if (locale === "fi") return fi_auth_error_signup_generic(inputs)
	if (locale === "da") return da_auth_error_signup_generic(inputs)
	if (locale === "sv") return sv_auth_error_signup_generic(inputs)
	return en_auth_error_signup_generic(inputs)
});